import { render, staticRenderFns } from "./customerInvoiceMiscCreditNote.vue?vue&type=template&id=60ce2fd2&scoped=true"
import script from "./customerInvoiceMiscCreditNote.vue?vue&type=script&lang=js"
export * from "./customerInvoiceMiscCreditNote.vue?vue&type=script&lang=js"
import style0 from "./customerInvoiceMiscCreditNote.vue?vue&type=style&index=0&id=60ce2fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce2fd2",
  null
  
)

export default component.exports